import Swiper from "swiper";

// Variable qui va contenir le swiper
let swiperFullContainer = []

/**
 * Déclenchement d'un swiper en mode full container avec 1 seul slide (permet de faire l'effet d'un slider classique)
 * @type {Swiper}
 */
function initSwiperFullContainer(HTMLSwiperElement)
{
    const defaultParams = {
        // sleep: 3000,
        init: true,
        slidesPerView: 1,
        spaceBetween: 40,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            disableOnInteraction : false,
            delay: 4000
        },
    }

    // Récupère les data-attribut sur l'objet déclarant le swiper et créer un objet en fonction du nom des attribut
    const dataParams = Object.assign({}, HTMLSwiperElement.dataset)
    if(dataParams.breakpoints)
    {
        dataParams.breakpoints = JSON.parse(dataParams.breakpoints)
    }

    const swiper = new Swiper(HTMLSwiperElement, Object.assign({}, defaultParams, dataParams))
    swiperFullContainer.push(swiper)
}

/**
 * Initialise les éléments swiper via leur sélecteur HTML
 */
const initSwiperElements = function() {

    const swiperElements = document.querySelectorAll('.swiper-container-full')
    swiperElements.forEach(swiperElement => initSwiperFullContainer(swiperElement))
}

/**
 * Détruit les instance de swiper
 */
const destroySwiper = function () {

    swiperFullContainer.forEach(swiper => swiper.destroy())
}

// Pour les swiper en mode full-container, on les actives uniquement sur l'affichage > 1024px
const matchMedia = window.matchMedia('(min-width: 1024px)')

// Affiche le swipe ou non en fonction de la taille de l'écran
if(matchMedia.matches) {
    initSwiperElements()
}

if(matchMedia.addEventListener)
{
    // Vérification de la taille de l'écran pour afficher ou non le swipe
    matchMedia.addEventListener('change', () => {

        if(matchMedia.matches) { initSwiperElements() }
        else { destroySwiper(); }
    })
}
else if(matchMedia.addListener)
{
    matchMedia.addListener(() => {
        if(matchMedia.matches) { initSwiperElements() }
        else { destroySwiper() }
    })
}

// Si on est pas sur internet explorer
// if(!/MSIE \d|Trident.*rv:/.test(navigator.userAgent))
// {
//
// }
// // Cas pour internet explorer
// else
// {
//
// }
